import { createSlice } from '@reduxjs/toolkit'

export const slice = createSlice({
  name: 'socket',
  initialState: {
    connected: null,
  },
  reducers: {
    setConnected: (state, action) => {
      state.connected = action.payload
    },
    setPaired: (state, action) => {
      state.paired = action.payload
    },
    setState: (state, action) => {
      // console.log('Action', action.payload)
      return {
        ...state,
        ...action.payload,
      }
    }
  },
})

export const { setConnected, setPaired, setState } = slice.actions

export default slice.reducer
